// ── Carousel slide video buttons (used inside <li> slides, not <nss-video-card>) ──
function initVideoSlideButtons(root) {
    root.querySelectorAll(".nss-carousel-slide-video").forEach((slide) => {
        const video   = slide.querySelector("video");
        const playBtn = slide.querySelector("[nss-carousel-slide-video-btn]");
        const muteBtn = slide.querySelector("[nss-carousel-slide-video-mute]");

        if (!video) return;

        // Play / pause
        if (playBtn && !playBtn.dataset.nssInit) {
            playBtn.dataset.nssInit = "1";
            playBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                const videoWrapper = slide.querySelector("[nss-video-playing]");
                if (video.paused) {
                    video.muted = muteBtn
                        ? muteBtn.classList.contains("nss-muted")
                        : false;
                    video.play();
                    if (videoWrapper) videoWrapper.setAttribute("nss-video-playing", "true");
                } else {
                    video.pause();
                    if (videoWrapper) videoWrapper.setAttribute("nss-video-playing", "false");
                }
            });
        }

        // Mute / unmute
        if (muteBtn && !muteBtn.dataset.nssInit) {
            muteBtn.dataset.nssInit = "1";
            video.muted = true;
            muteBtn.classList.add("nss-muted");
            muteBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                video.muted = !video.muted;
            });
            // Keep button in sync whenever anything changes video.muted
            video.addEventListener("volumechange", () => {
                muteBtn.classList.toggle("nss-muted", video.muted);
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", () => initVideoSlideButtons(document));

if (!customElements.get("nss-video-card")) {
    customElements.define(
        "nss-video-card",
        class NSSVideoCard extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    toggle: ".js-nss-video-card-toggle",
                    muteBtn: "[nss-carousel-slide-video-mute]",
                    video: "video"
                };
                this.video = this.querySelector(this.selectors.video);
                this.toggle = this.querySelector(this.selectors.toggle);
                this.muteBtn = this.querySelector(this.selectors.muteBtn);

                if (!this.video || !this.toggle) return;

                this.init();
            }

            play() {
                this.pauseOtherCards();
                this.video.play();
                this.classList.add("is-video-playing");
            }

            pause() {
                this.video.pause();
                this.classList.remove("is-video-playing");
            }

            pauseOtherCards() {
                this.closest('nss-carousel')?.querySelectorAll("nss-video-card.is-video-playing").forEach((card) => {
                        if (card !== this) {
                            card.pause();
                        }
                    });
            }

            toggleVideo() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }

            toggleMute() {
                this.video.muted = !this.video.muted;
                if (this.muteBtn) {
                    this.muteBtn.classList.toggle("nss-muted", this.video.muted);
                }
            }

            init() {
                this.toggle.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.toggleVideo();
                });

                if (this.muteBtn) {
                    this.video.muted = true;
                    this.muteBtn.classList.add("nss-muted");
                    this.muteBtn.addEventListener("click", (e) => {
                        e.stopPropagation();
                        this.toggleMute();
                    });
                }

                // Sync state with native controls
                this.video.addEventListener("play", () => {
                    this.pauseOtherCards();
                    this.classList.add("is-video-playing");
                });

                this.video.addEventListener("pause", () => {
                    this.classList.remove("is-video-playing");
                });
            }
        }
    );
}
